import React from 'react';
import { SearchableTable } from 'components/List';
import NoPagesAlert from 'containers/SearchablePagesTable/NoPagesAlert';
import PagesPagination from 'containers/PagesPagination';

const propTypes = {};

const defaultProps = {};

const SearchablePagesTable = (props) => {
  const noResultsComponent = <NoPagesAlert />;

  return (
    <React.Fragment>
      <SearchableTable {...props} noResultsComponent={noResultsComponent} />
      <PagesPagination />
    </React.Fragment>
  );
};

SearchablePagesTable.propTypes = propTypes;
SearchablePagesTable.defaultProps = defaultProps;

export default SearchablePagesTable;
